export default __webpack_public_path__ + "static/media/cert-E-commerce-HKIRC.dddd627c.jpg";